// 系统数据
import systemDict from '@/views/systemData/systemDict/systemDict';

import subjectList from '@/views/systemData/subjectManagement/subjectList';
import subjectAddEdit from '@/views/systemData/subjectManagement/subjectAddEdit';


import schoolCalendarIndex from '@/views/systemData/schoolCalendar/schoolCalendarIndex';
import schoolCalendarAdd from '@/views/systemData/schoolCalendar/schoolCalendarAdd';
import schoolCalendarEdit from '@/views/systemData/schoolCalendar/schoolCalendarEdit';
import schoolCalendarSet from '@/views/systemData/schoolCalendar/schoolCalendarSet';
//用户手册
import userManualIndex from '@/views/systemData/userManual/userManualIndex';
import userManualList from '@/views/systemData/userManual/userManualList';
// 班牌模板
import classcardModuleList from '@/views/classcard/modules/moduleList';
import classcardModuleAddEdit from '@/views/classcard/modules/moduleAddEdit';
//平台商户
import platformmerchantindex from '@/views/platformmerchant/platformmerchantindex';
import platformmerchantadd from '@/views/platformmerchant/platformmerchantadd';
import platformmerchanteidt from '@/views/platformmerchant/platformmerchanteidt';
import platformmerchantlist from '@/views/platformmerchant/platformmerchantlist';
import merchantstatistics from '@/views/platformmerchant/merchantstatistics';
import merchantstatisticslist from '@/views/platformmerchant/merchantstatisticslist';
import cashoutreconciliation from '@/views/platformmerchant/cashoutreconciliation';
import cashoutreconciliationinfo from '@/views/platformmerchant/cashoutreconciliationinfo';

import templateCustomSetting from '@/views/classcard/template/templateCustomSetting';
import templateCustomSettingVertical from '@/views/classcard/template/templateCustomSettingVertical';
import templateList from '@/views/classcard/template/templateList';
import templateDataboardCustomSetting from '@/views/classcard/template/templateDataboardCustomSetting';

// 经销商管理
import dealerManageList from '@/views/dealerManage/dealer/dealerManageList';
import dealerManageAdd from '@/views/dealerManage/dealer/dealerManageAdd';
import dealerManageUserList from '@/views/dealerManage/dealer/dealerManageUserList';

import customerServiceGroupList from '@/views/dealerManage/customerService/customerServiceGroupList';
import customerServiceGroupAdd from '@/views/dealerManage/customerService/customerServiceGroupAdd';

import platformRoleIndex from '@/views/dealerManage/platformRole/platformRoleIndex';
import dealerSuiteIndex from '@/views/dealerManage/dealerSuite/dealerSuiteIndex';
import dealerSuiteInfo from '@/views/dealerManage/dealerSuite/dealerSuiteInfo';

// 学习
import charLib from '@/views/study/charLib/charLib';

import libraryIndex from '@/views/study/library/libraryIndex';
import libraryAdd from '@/views/study/library/libraryAdd';
import libraryEdit from '@/views/study/library/libraryEdit';
import libraryDetail from '@/views/study/library/libraryDetail';
import libraryToExamine from '@/views/study/library/libraryToExamine';

import resourceMapIndex from '@/views/study/resourceMap/resourceMapIndex';
import resourceSubjectIndex from '@/views/study/resourceMap/resourceSubjectIndex';
import resourceSubjectAdd from '@/views/study/resourceMap/resourceSubjectAdd';
import resourceSubjectEdit from '@/views/study/resourceMap/resourceSubjectEdit';
import resourceCourseIndex from '@/views/study/resourceMap/resourceCourseIndex';
import resourceCourseList from '@/views/study/resourceMap/resourceCourseList';
import resourceMenuAdd from '@/views/study/resourceMap/resourceMenuAdd';
import resourceLessonAdd from '@/views/study/resourceMap/resourceLessonAdd';

// 硬件管理
import cardList from '@/views/hardwareManage/cardList';
import cardInfo from '@/views/hardwareManage/cardInfo';
import equipmentLibraryIndex from '@/views/hardwareManage/equipmentLibraryIndex';
import equipmentLibraryForm from '@/views/hardwareManage/form';
import deviceAccounting from '@/views/hardwareManage/deviceAccounting';
import deviceAccountingBySchool from '@/views/hardwareManage/deviceAccountingBySchool';


// 成长册 start
import growthBookIndex from '@/views/growthBook/index';
import growthBookForm from '@/views/growthBook/form';
// 成长册 end


//成绩
import achievementindex from '@/views/achievement/achievementindex';
import achievementadd from '@/views/achievement/achievementadd';
import achievementeidt from '@/views/achievement/achievementeidt';
import achievementTypeadd from '@/views/achievement/achievementTypeadd';
import achievementTypeeidt from '@/views/achievement/achievementTypeeidt';
import achievementTypeindex from '@/views/achievement/achievementTypeindex';
//膳食
import nutritionSettingsindex from '@/views/foodSetting/nutritionSettingsindex';
import nutritionSettingstype from '@/views/foodSetting/nutritionSettingstype';
import expertCookbookindex from '@/views/foodSetting/expertCookbookindex';
import expertCookbookeidt from '@/views/foodSetting/expertCookbookeidt';
import expertCookbookadd from '@/views/foodSetting/expertCookbookadd';
import expertCookbookInfo from '@/views/foodSetting/expertCookbookInfo';
import varietyofdishesindex from '@/views/foodSetting/varietyofdishesindex';
import varietyofdishesadd from '@/views/foodSetting/varietyofdishesadd';
import varietyofdisheseidt from '@/views/foodSetting/varietyofdisheseidt';
import varietyofdishesInfo from '@/views/foodSetting/varietyofdishesInfo';
import varietyofdisheslist from '@/views/foodSetting/varietyofdisheslist';
import varietyofdisheslisteidt from '@/views/foodSetting/varietyofdisheslisteidt';
import varietyofdisheslistInfo from '@/views/foodSetting/varietyofdisheslistInfo';
import foodWarehouseindex from '@/views/foodSetting/foodWarehouseindex';
import foodWarehouseadd from '@/views/foodSetting/foodWarehouseadd';
import foodWarehouseInfo from '@/views/foodSetting/foodWarehouseInfo';
import foodWarehouseeidt from '@/views/foodSetting/foodWarehouseeidt';
import recipesindex from '@/views/foodSetting/recipesindex';
import recipeslist from '@/views/foodSetting/recipeslist';
import recipesadd from '@/views/foodSetting/recipesadd';

// 敏感词
import wordBlackList from '@/views/wordBlacklist/wordBlacklist';
import logList from '@/views/log/logList';

// 积分银行
import cardTemplateList from '@/views/integralBank/cardTemplateList';
import cardTemplateAdd from '@/views/integralBank/cardTemplateAdd';
import cardTemplateInfo from '@/views/integralBank/cardTemplateInfo';
import cardManageList from '@/views/integralBank/cardManageList';
import cardBatchAdd from '@/views/integralBank/cardBatchAdd';
import cardManageInfo from '@/views/integralBank/cardManageInfo';
import cardUseRecord from '@/views/integralBank/cardUseRecord';
import goodsManageList from '@/views/integralBank/goodsManageList';
import goodsManageAdd from '@/views/integralBank/goodsManageAdd';
import goodsManageInfo from '@/views/integralBank/goodsManageInfo';

// 数据下发
import pushDataLog from '@/views/pushData/pushDataLog';
import changeLog from '@/views/pushData/changeLog';

// 积分规则
import integralruleindex from '@/views/integralrule/integralruleindex';
import integralruleadd from '@/views/integralrule/integralruleadd';
import integralruleeidt from '@/views/integralrule/integralruleeidt';


import watchingRecordsSettingList from '@/views/watchingRecords/watchingRecordsSettingList';
import watchingRecordsSettingDetail from '@/views/watchingRecords/watchingRecordsSettingDetail';
import watchingRecordsSettingAddEdit from '@/views/watchingRecords/watchingRecordsSettingAddEdit';

//幼儿成长档案
import growthfootprintevaluationtemplateindex from '@/views/growthfootprint/growthfootprintevaluationtemplateindex';
import growthfootprintevaluationtemplateeidt from '@/views/growthfootprint/growthfootprintevaluationtemplateeidt';
import growthfootprinttypesettingindex from '@/views/growthfootprint/growthfootprinttypesettingindex';
import growthfootprintassemblyindex from '@/views/growthfootprint/growthfootprintassemblyindex';
import growthfootprintassemblyadd from '@/views/growthfootprint/growthfootprintassemblyadd';
import growthfootprintassemblydetailsadd from '@/views/growthfootprint/growthfootprintassemblydetailsadd';
import growthfootprintassemblyaddtwo from '@/views/growthfootprint/growthfootprintassemblyaddtwo';
import growthfootprintassemblyaddthree from '@/views/growthfootprint/growthfootprintassemblyaddthree';


import sqlTemplateList from '@/views/sql/sqlTemplateList';
import sqlTemplateAddEdit from '@/views/sql/sqlTemplateAddEdit';
import sqlTemplateDetail from '@/views/sql/sqlTemplateDetail';
import sqlExecList from '@/views/sql/sqlExecList';
import sqlTemplateExec from '@/views/sql/sqlTemplateExec';

export default [
    // 系统数据
    {
        path: 'systemMaintain',
        redirect: 'systemMaintain/systemData/systemDict'
    },
    {
        path: 'systemMaintain/systemData/systemDict',
        component: systemDict
    },
    {
        path: 'systemMaintain/systemData/subjectManagement/subjectList',
        component: subjectList
    },
    {
        path: 'systemMaintain/systemData/subjectManagement/subjectAddEdit',
        component: subjectAddEdit
    },
    {
        path: 'systemMaintain/systemData/schoolCalendar/schoolCalendarList',
        component: schoolCalendarIndex
    },
    {
        path: 'systemMaintain/systemData/schoolCalendar/schoolCalendarAdd',
        component: schoolCalendarAdd
    },
    {
        path: 'systemMaintain/systemData/schoolCalendar/schoolCalendarEdit',
        component: schoolCalendarEdit
    },
    {
        path: 'systemMaintain/systemData/schoolCalendar/schoolCalendarSet',
        component: schoolCalendarSet
    },
    // 用户手册
    {
        path: 'systemMaintain/systemData/userManual/userManualIndex',
        component: userManualIndex
    },
    {
        path: 'systemMaintain/systemData/userManual/userManualList',
        component: userManualList
    },
    //userManualIndex
    {
        path: 'systemMaintain/systemData/platformmerchant/platformmerchantindex',
        component: platformmerchantindex
    },
    {
        path: 'systemMaintain/systemData/platformmerchant/platformmerchantadd',
        component: platformmerchantadd
    },
    {
        path: 'systemMaintain/systemData/platformmerchant/platformmerchanteidt',
        component: platformmerchanteidt
    },
    {
        path: 'systemMaintain/systemData/platformmerchant/platformmerchantlist',
        component: platformmerchantlist
    },
    {
        path: 'systemMaintain/systemData/platformmerchant/merchantstatistics',
        component: merchantstatistics
    },
    {
        path: 'systemMaintain/systemData/platformmerchant/merchantstatisticslist',
        component: merchantstatisticslist
    },
    {
        path: 'systemMaintain/systemData/platformmerchant/cashoutreconciliation',
        component: cashoutreconciliation
    },
    {
        path: 'systemMaintain/systemData/platformmerchant/cashoutreconciliationinfo',
        component: cashoutreconciliationinfo
    },
    // 班牌模板
    {
        path: 'systemMaintain/classcard/module/moduleList',
        component: classcardModuleList,
        meta: {
            isCached: true
        }
    },
    {
        path: 'systemMaintain/classcard/module/moduleAddEdit',
        component: classcardModuleAddEdit
    },
    {
        path: 'systemMaintain/classcard/template/templateCustomSetting',
        component: templateCustomSetting
    },
    {
        path: 'systemMaintain/classcard/template/templateCustomSettingVertical',
        component: templateCustomSettingVertical
    },
    {
        path: 'systemMaintain/classcard/template/templateList',
        component: templateList
    },
    {
        path: 'systemMaintain/classcard/template/temolateDataboardCustomSetting',
        component: templateDataboardCustomSetting
    },

    // 经销商管理
    {
        path: 'systemMaintain/dealerManage/dealer/dealerManageList',
        component: dealerManageList
    },
    {
        path: 'systemMaintain/dealerManage/dealer/dealerManageAdd',
        component: dealerManageAdd
    },
    {
        path: 'systemMaintain/dealerManage/dealer/dealerManageUserList',
        component: dealerManageUserList
    },
    {
        path: 'systemMaintain/dealerManage/customerService/groupList',
        component: customerServiceGroupList
    },
    {
        path: 'systemMaintain/dealerManage/customerService/groupAdd',
        component: customerServiceGroupAdd
    },
    {
        path: 'systemMaintain/dealerManage/platformRole/platformRoleIndex',
        component: platformRoleIndex,
        meta: {
            isCached: true
        }
    },
    {
        path: 'systemMaintain/dealerManage/dealerSuite/dealerSuiteIndex',
        component: dealerSuiteIndex
    },
    {
        path: 'systemMaintain/dealerManage/dealerSuite/dealerSuiteInfo',
        component: dealerSuiteInfo
    },
    // 学习
    {
        path: 'systemMaintain/study/charLib/charLib',
        component: charLib
    },
    {
        path: 'systemMaintain/study/library/libraryIndex',
        component: libraryIndex
    },
    {
        path: 'systemMaintain/study/library/libraryAdd',
        component: libraryAdd
    },
    {
        path: 'systemMaintain/study/library/libraryEdit',
        component: libraryEdit
    },
    {
        path: 'systemMaintain/study/library/libraryDetail',
        component: libraryDetail
    },
    {
        path: 'systemMaintain/study/library/libraryToExamine',
        component: libraryToExamine
    },
    {
        path: 'systemMaintain/study/resourceMap/resourceMapIndex',
        component: resourceMapIndex
    },
    {
        path: 'systemMaintain/study/resourceMap/resourceSubjectIndex',
        component: resourceSubjectIndex
    },
    {
        path: 'systemMaintain/study/resourceMap/resourceSubjectAdd',
        component: resourceSubjectAdd
    },
    {
        path: 'systemMaintain/study/resourceMap/resourceSubjectEdit',
        component: resourceSubjectEdit
    },
    {
        path: 'systemMaintain/study/resourceMap/resourceCourse',
        component: resourceCourseIndex,
        children: [{
                path: '/',
                redirect: 'list'
            },
            {
                path: 'list',
                component: resourceCourseList
            },
            {
                path: 'menuAdd',
                component: resourceMenuAdd
            },
            {
                path: 'lessonAdd',
                component: resourceLessonAdd
            }
        ]
    },
    // 硬件管理
    {
        path: 'systemMaintain/hardwareManage/cardList',
        component: cardList
    },
    {
        path: 'systemMaintain/hardwareManage/cardInfo',
        component: cardInfo
    },
    {
        path: 'systemMaintain/hardwareManage/equipmentLibraryIndex',
        component: equipmentLibraryIndex,
        meta: {
            isCached: true
        }
    },
    {
        path: 'systemMaintain/hardwareManage/form',
        component: equipmentLibraryForm
    },
    {
        path: 'systemMaintain/hardwareManage/deviceAccounting',
        component: deviceAccounting
    },
    {
        path: 'systemMaintain/hardwareManage/deviceAccountingBySchool',
        component: deviceAccountingBySchool
    },
    // 成长册 start
    {
        path: 'systemMaintain/growthBook/index',
        component: growthBookIndex
    },
    {
        path: 'systemMaintain/growthBook/form',
        component: growthBookForm
    },
    // 成长册 end

    //成绩
    {
        path: 'systemMaintain/study/achievement/achievementindex',
        component: achievementindex
    },
    {
        path: 'systemMaintain/study/achievement/achievementadd',
        component: achievementadd
    },
    {
        path: 'systemMaintain/study/achievement/achievementeidt',
        component: achievementeidt
    },
    {
        path: 'systemMaintain/study/achievement/achievementTypeadd',
        component: achievementTypeadd
    },
    {
        path: 'systemMaintain/study/achievement/achievementTypeeidt',
        component: achievementTypeeidt
    },
    {
        path: 'systemMaintain/study/achievement/achievementTypeindex',
        component: achievementTypeindex
    },
    //膳食
    {
        path: 'systemMaintain/foodSetting/nutritionSettingsindex',
        component: nutritionSettingsindex
    },
    {
        path: 'systemMaintain/foodSetting/nutritionSettingstype',
        component: nutritionSettingstype
    },
    {
        path: 'systemMaintain/foodSetting/expertCookbookindex',
        component: expertCookbookindex
    },
    {
        path: 'systemMaintain/foodSetting/expertCookbookadd',
        component: expertCookbookadd
    },
    {
        path: 'systemMaintain/foodSetting/expertCookbookeidt',
        component: expertCookbookeidt
    },
    {
        path: 'systemMaintain/foodSetting/expertCookbookInfo',
        component: expertCookbookInfo
    },
    {
        path: 'systemMaintain/foodSetting/varietyofdishesindex',
        component: varietyofdishesindex
    },
    {
        path: 'systemMaintain/foodSetting/varietyofdishesadd',
        component: varietyofdishesadd
    },
    {
        path: 'systemMaintain/foodSetting/varietyofdisheseidt',
        component: varietyofdisheseidt
    },
    {
        path: 'systemMaintain/foodSetting/varietyofdishesInfo',
        component: varietyofdishesInfo
    },
    {
        path: 'systemMaintain/foodSetting/varietyofdisheslist',
        component: varietyofdisheslist
    },
    {
        path: 'systemMaintain/foodSetting/varietyofdisheslisteidt',
        component: varietyofdisheslisteidt
    },
    {
        path: 'systemMaintain/foodSetting/varietyofdisheslistInfo',
        component: varietyofdisheslistInfo
    },
    {
        path: 'systemMaintain/foodSetting/foodWarehouseindex',
        component: foodWarehouseindex
    },
    {
        path: 'systemMaintain/foodSetting/foodWarehouseeidt',
        component: foodWarehouseeidt
    },
    {
        path: 'systemMaintain/foodSetting/foodWarehouseadd',
        component: foodWarehouseadd
    },
    {
        path: 'systemMaintain/foodSetting/foodWarehouseInfo',
        component: foodWarehouseInfo
    },
    {
        path: 'systemMaintain/foodSetting/recipesindex',
        component: recipesindex
    },
    {
        path: 'systemMaintain/foodSetting/recipeslist',
        component: recipeslist
    },
    {
        path: 'systemMaintain/foodSetting/recipesadd',
        component: recipesadd
    },
    {
        path: 'systemMaintain/wordBlackList',
        component: wordBlackList
    },
    {
        path: 'systemMaintain/pushData/logList',
        component: logList
    },

    // 积分银行
    {
        path: 'systemMaintain/integralBank/cardTemplateList',
        component: cardTemplateList,
        meta: {
            isCached: true
        }
    },
    {
        path: 'systemMaintain/integralBank/cardTemplateAdd',
        component: cardTemplateAdd
    },
    {
        path: 'systemMaintain/integralBank/cardTemplateInfo',
        component: cardTemplateInfo
    },
    {
        path: 'systemMaintain/integralBank/cardManageList',
        component: cardManageList,
        meta: {
            isCached: true
        }
    },
    {
        path: 'systemMaintain/integralBank/cardBatchAdd',
        component: cardBatchAdd
    },
    {
        path: 'systemMaintain/integralBank/cardManageInfo',
        component: cardManageInfo
    },
    {
        path: 'systemMaintain/integralBank/cardUseRecord',
        component: cardUseRecord
    },
    {
        path: 'systemMaintain/integralBank/goodsManageList',
        component: goodsManageList
    },
    {
        path: 'systemMaintain/integralBank/goodsManageAdd',
        component: goodsManageAdd
    },
    {
        path: 'systemMaintain/integralBank/goodsManageInfo',
        component: goodsManageInfo
    },
    {
        path: 'systemMaintain/integralrule/integralruleindex',
        component: integralruleindex
    },
    {
        path: 'systemMaintain/integralrule/integralruleadd',
        component: integralruleadd
    },
    {
        path: 'systemMaintain/integralrule/integralruleeidt',
        component: integralruleeidt
    },
    {
        path: 'systemMaintain/watchingRecords/watchingRecordsSettingList',
        component: watchingRecordsSettingList

    },
    {
        path: 'systemMaintain/watchingRecords/watchingRecordsSettingDetail',
        component: watchingRecordsSettingDetail

    },
    {
        path: 'systemMaintain/watchingRecords/watchingRecordsSettingAddEdit',
        component: watchingRecordsSettingAddEdit
    },
    {
        path: 'systemMaintain/growthfootprint/growthfootprintevaluationtemplateindex',
        component: growthfootprintevaluationtemplateindex
    },
    {
        path: 'systemMaintain/growthfootprint/growthfootprintevaluationtemplateeidt',
        component: growthfootprintevaluationtemplateeidt
    },
    {
        path: 'systemMaintain/growthfootprint/growthfootprinttypesettingindex',
        component: growthfootprinttypesettingindex
    },
    {
        path: 'systemMaintain/growthfootprint/growthfootprintassemblyindex',
        component: growthfootprintassemblyindex
    },
    {
        path: 'systemMaintain/growthfootprint/growthfootprintassemblydetailsadd',
        component: growthfootprintassemblydetailsadd
    },
    {
        path: 'systemMaintain/growthfootprint/growthfootprintassemblyadd',
        component: growthfootprintassemblyadd
    },
    {
        path: 'systemMaintain/growthfootprint/growthfootprintassemblyaddtwo',
        component: growthfootprintassemblyaddtwo
    },
    {
        path: 'systemMaintain/growthfootprint/growthfootprintassemblyaddthree',
        component: growthfootprintassemblyaddthree
    },
    // 数据下发  
    {
        path: 'systemMaintain/pushData/pushDataLog',
        component: pushDataLog
    },
    {
        path: 'systemMaintain/pushData/changeLog',
        component: changeLog,
        meta: {
            isCached: true
        }
    },
    {
        path: 'systemMaintain/study/readingplatformsetup',
        component: () => import('@/views/readingplatform/readingplatformsetup')
    },
    {
        path: 'systemMaintain/study/readingplatformindex',
        component: () => import('@/views/readingplatform/readingplatformindex')
    },
    {
        path: 'systemMaintain/study/readingplatformbasicsettings',
        component: () => import('@/views/readingplatform/readingplatformbasicsettings')
    },
    {
        path: 'systemMaintain/study/readingplatformstateimg',
        component: () => import('@/views/readingplatform/readingplatformstateimg')
    },
    {
        path: 'systemMaintain/study/readingplatformadministrationindex',
        component: () => import('@/views/readingplatform/readingplatformadministrationindex')
    },
    {
        path: 'systemMaintain/study/readingplatformadministrationadd',
        component: () => import('@/views/readingplatform/readingplatformadministrationadd')
    },
    {
        path: 'systemMaintain/study/readingplatformadministrationeidt',
        component: () => import('@/views/readingplatform/readingplatformadministrationeidt')
    },
    {
        path: 'systemMaintain/study/readingplatformgradeindex',
        component: () => import('@/views/readingplatform/readingplatformgradeindex')
    },
    {
        path: 'systemMaintain/study/readingplatformgradeadd',
        component: () => import('@/views/readingplatform/readingplatformgradeadd')
    },
    {
        path: 'systemMaintain/study/readingplatformgradeeidt',
        component: () => import('@/views/readingplatform/readingplatformgradeeidt')
    },
    {
        path: 'systemMaintain/study/readingplatformmapindex',
        component: () => import('@/views/readingplatform/readingplatformmapindex')
    },
    {
        path: 'systemMaintain/study/readingplatformmapeidt',
        component: () => import('@/views/readingplatform/readingplatformmapeidt')
    },
    {
        path: 'systemMaintain/study/readingplatformmapadd',
        component: () => import('@/views/readingplatform/readingplatformmapadd')
    },
    {
        path: 'systemMaintain/study/readingplatformbookmanagementindex',
        component: () => import('@/views/readingplatform/readingplatformbookmanagementindex')
    },
    {
        path: 'systemMaintain/study/readingplatformbookmanagementerimg',
        component: () => import('@/views/readingplatform/readingplatformbookmanagementerimg')
    },
    {
        path: 'systemMaintain/study/readingplatformbookmanagementeidt',
        component: () => import('@/views/readingplatform/readingplatformbookmanagementeidt')
    },
    {
        path: 'systemMaintain/study/readingplatformbookmanagementdetails',
        component: () => import('@/views/readingplatform/readingplatformbookmanagementdetails')
    },
    {
        path: 'systemMaintain/study/readingplatformsubjectadd',
        component: () => import('@/views/readingplatform/readingplatformsubjectadd')
    },
    {
        path: 'systemMaintain/study/readingplatformsubjectdetails',
        component: () => import('@/views/readingplatform/readingplatformsubjectdetails')
    },
    {
        path: 'systemMaintain/study/readingplatformsubjecteidt',
        component: () => import('@/views/readingplatform/readingplatformsubjecteidt')
    },
    {
        path: 'systemMaintain/study/readingplatformsubjectlist',
        component: () => import('@/views/readingplatform/readingplatformsubjectlist')
    },

    {
        path: 'systemMaintain/sql/sqlTemplateList',
        component: sqlTemplateList
    },
    {
        path: 'systemMaintain/sql/sqlTemplateAddEdit',
        component: sqlTemplateAddEdit
    },
    {
        path: 'systemMaintain/sql/sqlTemplateDetail',
        component: sqlTemplateDetail
    },
    {
        path: 'systemMaintain/sql/sqlExecList',
        component: sqlExecList
    },
    {
        path: 'systemMaintain/sql/sqlTemplateExec',
        component: sqlTemplateExec
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/systemMaintain.js